import { useCallback, useEffect, useRef } from 'react';

export default function useLatestRequestSignal() {
  const controllerRef = useRef<AbortController | null>(null);

  useEffect(() => () => controllerRef.current?.abort(), []);

  return useCallback(() => {
    controllerRef.current?.abort();
    const controller = new AbortController();
    controllerRef.current = controller;

    return controller.signal;
  }, []);
}
